import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  tag: Box,
  propsNeeded: ['isCompleted'],
  styles: ({ isCompleted, theme }) => ({
    backgroundColor: isCompleted ? theme.palette.primary.light : theme.palette.background.grey.dark,
    borderRadius: theme.shape.rounded.full,
    height: '0.25rem',
    overflow: 'hidden',
    position: 'relative',
    maxWidth: '3rem',

    flex: '1 0 0',
  }),
});

export const ProgressAnimation = superstyled({
  tag: Box,
  propsNeeded: ['progressDuration'],
  styles: ({ progressDuration, theme }) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '-100%',

    backgroundColor: theme.palette.primary.light,
    borderRadius: theme.shape.rounded.full,
    width: '100%',

    animationDuration: `${progressDuration}ms`,
    animationFillMode: 'both',
    animationIterationCount: 1,
    animationName: 'autoplay',
    animationTimingFunction: 'linear',

    '@keyframes autoplay': {
      '0%': {
        transform: 'translateX(0)',
      },
      '100%': {
        transform: 'translateX(100%)',
      },
    },
  }),
});
